import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { catchError, switchMap, tap, take } from 'rxjs/operators';
import * as fromRoot from '../store';

import * as fromSelector from '../store/selectors';
import * as fromUserActions from '../store/actions/user.actions';
import { User } from '../models/user.model';

@Injectable()
export class UserGuard implements CanActivate {
  constructor(private store: Store<fromRoot.State>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromSelector.getUserData),
      tap((resp: User) => {
        if (!Object.getOwnPropertyNames(resp).length) {
          this.store.dispatch(new fromUserActions.LoadUser());
        }
      }),
      take(1),
      switchMap(() => of(true)),
      catchError(() => of(false)),
    );
  }
}
